export enum PlaceType {
  Province = 'Province', // eg: Ontario
  Region = 'Region', // eg: Durham or Georgian Bay
  County = 'County', // eg. Cape Breton
  District = 'District', // eg. Thunder Bay
  City = 'City', // eg: Toronto
  Village = 'Village',
  Municipality = 'Municipality',
  Town = 'Town',
  Locality = 'Locality', // eg: North York
  Neighborhood = 'Neighborhood', // eg: The Beaches
  Street = 'Street', // eg: Rawlinson Ave
  Postcode = 'Postcode',
  Intersection = 'Intersection',
  Address = 'Address',
  Place = 'Place', // Fallback
}
